import React, { Fragment, useContext, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Label } from "reactstrap";
import DataTable from "react-data-table-component";
import { useForm } from "react-hook-form";
import { getScheduledTripsTable } from "../../../Services/DispatchDashboard.service";
import { formatDateTime } from "../../../Services/Shared.service";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import SharedDataContext from "../../../_helper/SharedData";
import { useNavigate } from "react-router";

const data = [
  {
    date: "01.01.2023",
    amritsar: 10,
    bangalore: 7,
    delhi: 3,
    grand_total: 19,
  },
  {
    date: "01.01.2023",
    amritsar: 10,
    bangalore: 7,
    delhi: 3,
    grand_total: 19,
  },
  {
    date: "01.01.2023",
    amritsar: 10,
    bangalore: 7,
    delhi: 3,
    grand_total: 19,
  },
  {
    date: "01.01.2023",
    amritsar: 10,
    bangalore: 7,
    delhi: 3,
    grand_total: 19,
  },
  {
    date: "01.01.2023",
    amritsar: 10,
    bangalore: 7,
    delhi: 3,
    grand_total: 19,
  },
];

const ScheduledTripsTable = ({ cityData, globalCityField ,setShowApiLoader}) => {
  const [localFromDate, setLocalFromDate] = useState(() => {
    return moment(new Date());
  });
  const [showLoader,setShowLoader] = useState(false);
  const [loader,setLoader] = useState(false)
  const [localToDate, setLocalToDate] = useState(() => {
    return moment(new Date().setDate(new Date().getDate() + 5));
  });
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [cityObj, setCityObj] = useState({});
  const { register, watch } = useForm({
    defaultValues: {
      scheduled_trip_filter: "All",
    },
  });
  const scheduledTripFilter = watch("scheduled_trip_filter");
  const navigate = useNavigate();
  const {
    setDateFilter
  } = useContext(SharedDataContext);

  const handleDataClicked = (city,cityId,date,value) => {
    if(value != 0){
      localStorage.setItem('globalCityField', JSON.stringify({id: cityId, name: city}));
      globalCityField.onChange({id: cityId, name: city});
      setDateFilter({
        startDate: date,
        endDate: date,
        label: date
      })
      const filterData=[
          {
            key: "Pickup",
            column_name: "pick_up_date_time",
            values: [date],
          }
      ]
      if (scheduledTripFilter === "A2C") {
        filterData.push({
          key: "PICKUP TYPE",
          column_name: "pickup_type",
          values: ["AirportToCity"],
        });
      } else if (scheduledTripFilter === "C2A") {
        filterData.push({
          key: "PICKUP TYPE",
          column_name: "pickup_type",
          values: ["CityToAirport"],
        });
      }else if (scheduledTripFilter === "C2C") {
        filterData.push({
          key: "PICKUP TYPE",
          column_name: "pickup_type",
          values: ["CityToCity"],
        });
      }
      navigate("/booking/booking-history", {
        state: {
          filterdata: filterData
        }
      })
    }
  }

  useEffect(() => {
    if (tableData.length == 0) return;
    let array = [];
    const serviceCityId = globalCityField.value?.id || null;
    const data = tableData[scheduledTripFilter];
    if (!serviceCityId) {
      const columns = [
        {
          name: "DATE",
          selector: (row) => row["date"],
          sortable: true,
          center: true,
          // width:"130px",
        },
      ];
      cityData.map((element) => {
        columns.push({
          name: element.label.toUpperCase(),
          selector: (row) => row[element.label],
          sortable: true,
          center: true,
          // width:"130px",
        });
      });
      setColumns(columns);
      for (let date in data) {
        let obj = {
          date: date,
        };
        for (let cityId in data[date]) {
          obj[cityObj[cityId]] = <span style={data[date][cityId] != 0 ? {cursor: "pointer",textDecoration: "5px dashed underline" } : {}} onClick={()=>handleDataClicked(cityObj[cityId],cityId,date,data[date][cityId])}>{data[date][cityId]}</span>
        }
        array.push(obj);
      }
    } else {
      const columns = [
        {
          name: "DATE",
          selector: (row) => row["date"],
          sortable: true,
          center: true,
          // width:"130px",
        },
      ];
      columns.push({
        name: globalCityField.value?.name.toUpperCase(),
        selector: (row) => row[globalCityField.value?.name],
        sortable: true,
        center: true,
        // width:"130px",
      });
      setColumns(columns);
      for (let date in data) {
        let obj = {
          date: date,
        };
        obj[cityObj[serviceCityId]] = <span style={data[date][serviceCityId] != 0 ? {cursor: "pointer",textDecoration: "5px dashed underline"} : {}} onClick={()=>handleDataClicked(cityObj[serviceCityId],serviceCityId,date,data[date][serviceCityId])}>{data[date][serviceCityId]}</span>
        array.push(obj);
      }
    }

    setFilteredData(array);
  }, [tableData, scheduledTripFilter, globalCityField]);
  useEffect(() => {
    if (cityData.length == 0) return;
    let cityObj = {};
    cityData.map((element) => {
      cityObj[element.id] = element.label;
    });
    setCityObj(cityObj);
    console.log("fdjnkfjnkfknjgfkgf");
    const formatFromDate = formatDateTime(localFromDate, "YYYY-MM-DD");
    const formateToDate = formatDateTime(localToDate, "YYYY-MM-DD");
    let body = {
      from: formatFromDate,
      to: formateToDate,
    };
    if(showLoader) setLoader(true);
    getScheduledTripsTable(body).then((result) => {
      if(showLoader) setLoader(false);
      if (result.data) {
        const array = ["All", "A2C", "C2A", "C2C"];
        let response = {};
        array.forEach((element) => {
          let dateObj = {};
          let startDateTime = moment(new Date(localFromDate));
          let endDateTime = moment(new Date(localToDate));
          let formatStartDate = formatDateTime(startDateTime, "YYYY-MM-DD");
          let formateEndDate = formatDateTime(endDateTime, "YYYY-MM-DD");
          while (formatStartDate != formateEndDate) {
            dateObj[formatStartDate] = {};
            cityData.map((element) => {
              dateObj[formatStartDate][element.id] = 0;
            });
            startDateTime.add(1, "d");
            formatStartDate = formatDateTime(startDateTime, "YYYY-MM-DD");
          }
          response[element] = dateObj;
        });
        result.data.forEach((element) => {
          if (!response.All[element.Date]) return;
          response.All[element.Date][element.ServiceCityId] += Number(
            element.Count
          );
          if (element["Pickup Type"] == "AirportToCity") {
            response.A2C[element.Date][element.ServiceCityId] += Number(
              element.Count
            );
          } else if (element["Pickup Type"] == "CityToAirport") {
            response.C2A[element.Date][element.ServiceCityId] += Number(
              element.Count
            );
          } else if (element["Pickup Type"] == "CityToCity") {
            response.C2C[element.Date][element.ServiceCityId] += Number(
              element.Count
            );
          }
        });
        console.log(response, "responseresponse");
        setTableData(response);
      }
    }).catch(err=>{
      if(showLoader) setLoader(false)
    });
  }, [cityData, localFromDate, localToDate]);

  const getPrevDaysData = () => {
    console.log("callejkdfjknfjnkfjnk");
    setShowLoader(true);
    let startDateTime = moment(new Date(localFromDate));
    let endDateTime = moment(new Date(localToDate));
    startDateTime.subtract(5,'d');
    endDateTime.subtract(5,'d');
    setLocalFromDate(startDateTime);
    setLocalToDate(endDateTime);
  };

  const getNextDaysData = () => {
    console.log("called next day");
    setShowLoader(true);
    let startDateTime = moment(new Date(localFromDate));
    let endDateTime = moment(new Date(localToDate));
    startDateTime.add(5,'d');
    endDateTime.add(5,'d');
    setLocalFromDate(startDateTime);
    setLocalToDate(endDateTime);
  };


  const resetPagination = ()=>{
    console.log("called reset days");
    setLocalFromDate(moment(new Date()));
    setLocalToDate(moment(new Date().setDate(new Date().getDate() + 5)));
  };

  
  return (
    <Fragment>
      <Card className="scheduled-trips-table">
        <CardHeader>
          <div className="scheduled-trips-title">Scheduled Trips</div>
          <div className="m-checkbox-inline mb-0 custom-radio-ml">
            <div className="radio radio-primary">
              <input
                id="AllTrips"
                type="radio"
                {...register("scheduled_trip_filter")}
                value="All"
              />
              <Label className="mb-0" htmlFor="AllTrips">
                All
              </Label>
            </div>
            <div className="radio radio-primary">
              <input
                id="A2C"
                type="radio"
                value="A2C"
                {...register("scheduled_trip_filter")}
              />
              <Label className="mb-0" htmlFor="A2C">
                Airport to City
              </Label>
            </div>
            <div className="radio radio-primary">
              <input
                id="C2A"
                type="radio"
                value="C2A"
                {...register("scheduled_trip_filter")}
              />
              <Label className="mb-0" htmlFor="C2A">
                City to Airport
              </Label>
            </div>
            <div className="radio radio-primary">
              <input
                id="C2C"
                type="radio"
                value="C2C"
                {...register("scheduled_trip_filter")}
              />
              <Label className="mb-0" htmlFor="C2C">
                City to City
              </Label>
            </div>
          </div>
          <div className="table-pagination">
            <button
              className="pagination-btn"
              onClick={() => getPrevDaysData()}
            >
              <i className="fa fa-chevron-circle-left"></i>
            </button>
            <button
              className="pagination-btn"
              onClick={() => getNextDaysData()}
            >
              <i className="fa fa-chevron-circle-right"></i>
            </button>
            <button className="pagination-btn" onClick={() => resetPagination()}>
              <i className="fa fa-repeat"></i>
            </button>
          </div>
        </CardHeader>
        <CardBody>
          <div className="table-responsive scheduled-trips-table">
            <DataTable
              columns={columns}
              data={filteredData}
              center={true}
              fixedHeader
              // customStyles={customStyles}
              progressPending={loader}
              progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ScheduledTripsTable;
